import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useFormikForm } from '#/common/hooks';
import { ROUTES } from '#/routes';
import { apiEndpoints, usePostMutation } from '#/services';
import {
    ACCESS_TOKEN,
    ResetPasswordValidationSchema,
    getLocalStorageItem,
    getSessionStorageItem,
    resetPasswordInInitialValues,
} from '#/utils';

export function useResetPassword() {
    const navigate = useNavigate();

    const { mutate: resetPassswordApiCall, isPending: resetPasswordApiLoading } = usePostMutation({
        url: apiEndpoints.RESET_PASSWORD,
        onSuccess: resetPasswordCallSuccess,
        successMessage: 'Password reset successfully!',
        errorMessage: 'Failed to reset password!',
    });

    function resetPasswordCallSuccess() {
        navigate(ROUTES.LOGIN);
    }

    const handleResetPassword = async values => {
        resetPassswordApiCall({
            payload: values,
        });
    };

    const navigateToLogin = () => {
        navigate(ROUTES.LOGIN);
    };

    const {
        handleChange: handleChangeReset,
        handleSubmit: handleSubmitReset,
        errors: resetErrors,
        touched: resetTouched,
        values: resetValues,
        setFieldValue: setResetValues,
    } = useFormikForm(resetPasswordInInitialValues, handleResetPassword, ResetPasswordValidationSchema);

    useEffect(() => {
        if (getLocalStorageItem(ACCESS_TOKEN) || getSessionStorageItem(ACCESS_TOKEN)) navigate(ROUTES.HOME);
    }, []);
    return {
        navigateToLogin,
        handleChangeReset,
        handleSubmitReset,
        resetErrors,
        resetTouched,
        resetValues,
        setResetValues,
        resetPasswordApiLoading,
    };
}
